import type { ReactionIcon } from "@/lib/room-state";

// Emoji-based reactions. Each reaction is a Unicode emoji character.
// The floating overlay renders them as text, the tray renders them as buttons.
export const REACTION_ICONS: Record<ReactionIcon, { emoji: string; label: string }> = {
  heart: { emoji: "\u2764\uFE0F", label: "Love" },
  flame: { emoji: "\uD83D\uDD25", label: "Fire" },
  laugh: { emoji: "\uD83D\uDE02", label: "Laugh" },
  popcorn: { emoji: "\uD83C\uDF7F", label: "Popcorn" },
  clap: { emoji: "\uD83D\uDC4F", label: "Clap" },
  party: { emoji: "\uD83C\uDF89", label: "Party" },
  wow: { emoji: "\uD83D\uDE32", label: "Wow" },
  rocket: { emoji: "\uD83D\uDE80", label: "Rocket" },
  thumbsup: { emoji: "\uD83D\uDC4D", label: "Thumbs Up" },
  cry: { emoji: "\uD83D\uDE22", label: "Cry" },
  angry: { emoji: "\uD83D\uDE21", label: "Angry" },
  skull: { emoji: "\uD83D\uDC80", label: "Skull" },
};

export const REACTION_ORDER: ReactionIcon[] = [
  "heart",
  "flame",
  "laugh",
  "popcorn",
  "clap",
  "party",
  "wow",
  "rocket",
  "thumbsup",
  "cry",
  "angry",
  "skull",
];
